/**
 * Generated by orval v8.8.0 🍺
 * Do not edit manually.
 * PatientPortal
 * OpenAPI spec version: v1
 */

export type FormFieldAssignee = typeof FormFieldAssignee[keyof typeof FormFieldAssignee];


export const FormFieldAssignee = {
  Patient: 'Patient',
  Clinician: 'Clinician',
} as const;
